// extracted by mini-css-extract-plugin
module.exports = {"label":"label___3l692","tag":"tag___2IBq-","container":"container___3OaMF"};